import {
    analyticsEventInit,
    analyticsEventMenuClick,
    analyticsEventSizeChartClick,
    analyticsEventContactUs,
    analyticsEventCustom,
    analyticsEventNewsletter,
    analyticsEventSearchLayer,
    analyticsEventExclusiveServicesClick,
    analyticsEventExclusiveServicesAppointmentClick,
    analyticsEventChangeLocale,
    analyticsUserData,
    analyticsProductImpression,
    analyticsEventInternalSearch,
    analyticsProductClick,
    analyticsDynamicPage,
    analyticsEventQuickCartAdd,
    analyticsEventWishlist,
    analyticsEventAddToCart,
    analyticsEventMinicartAddToCart,
    analyticsEventMinicartRemoveFromCart,
    analyticsFilters,
    analyticsEventLoadMore,
    analyticsEventCheckLocale,
    analyticsEventPromoView,
    analyticsEventPromoClick,
    analyticsEventWishlistShare,
    analyticsEventPwaPage,
    analyticsExpressPaymentStart,
    analyticsEventCloseLayer,
    analyticsEventMinicartLayer,
    analyticsEventVideo,
    analyticsEventWidget,
    analyticsEventCrossCategoryNavigationClick,
    analyticsEventTileImageCarouselSlideChange,
    analyticsGoToCart,
    analyticsProductSizeSelectorOpenClose,
    analyticsProductSizeSelectorSizeSelect,
    analyticsProductFindInBoutiqueBookAppointment,
    analyticsProductFindInBoutiqueCall,
    analyticsProductFindInBoutiqueCountryChange,
    analyticsProductFindInBoutiqueOpenLayer,
    analyticsProductFindInBoutiqueRedirect,
    analyticsProductFindInBoutiqueSizeSelection,
    analyticsEventProductDetail,
    analyticsEventRequestSize,
    analyticsEventPdpDetailLayer,
    analyticsEventPdpSizeGuideLayer,
    analyticsEventPdpColorLayer,
    analyticsEventPdpColorLayerSelect,
    analyticsEventPdpCarouselSwitch,
    analyticsEventConfirmLayerAddToCart,
    analyticsProductRelatedClick,
    analyticsEventStoriesMenuClick,
} from '_analytics/events'

/**
 * @name useAnalytics
 *
 * @description
 * Custom hook provides functions to track various analytics events.
 *
 * @hook
 * @returns {ReturnType<typeof useAnalytics>} An object containing functions to track analytics events.
 *
 * @example
 * ```tsx
 * const { analyticsEventMenuClick } = useAnalytics();
 *
 * analyticsEventMenuClick({});
 * ```
 */
const useAnalytics = () => {
    return {
        analyticsEventInit,
        analyticsEventCustom,
        analyticsEventMenuClick,
        analyticsEventSizeChartClick,
        analyticsEventContactUs,
        analyticsEventNewsletter,
        analyticsEventSearchLayer,
        analyticsEventExclusiveServicesClick,
        analyticsEventExclusiveServicesAppointmentClick,
        analyticsEventChangeLocale,
        analyticsUserData,
        analyticsProductImpression,
        analyticsEventInternalSearch,
        analyticsProductClick,
        analyticsDynamicPage,
        analyticsEventQuickCartAdd,
        analyticsEventWishlist,
        analyticsEventAddToCart,
        analyticsEventMinicartAddToCart,
        analyticsEventMinicartRemoveFromCart,
        analyticsFilters,
        analyticsEventLoadMore,
        analyticsEventCheckLocale,
        analyticsEventPromoView,
        analyticsEventPromoClick,
        analyticsEventWishlistShare,
        analyticsEventPwaPage,
        analyticsExpressPaymentStart,
        analyticsEventCloseLayer,
        analyticsEventMinicartLayer,
        analyticsEventVideo,
        analyticsEventWidget,
        analyticsEventCrossCategoryNavigationClick,
        analyticsEventTileImageCarouselSlideChange,
        analyticsGoToCart,
        analyticsProductSizeSelectorOpenClose,
        analyticsProductSizeSelectorSizeSelect,
        analyticsProductFindInBoutiqueBookAppointment,
        analyticsProductFindInBoutiqueCall,
        analyticsProductFindInBoutiqueCountryChange,
        analyticsProductFindInBoutiqueOpenLayer,
        analyticsProductFindInBoutiqueRedirect,
        analyticsProductFindInBoutiqueSizeSelection,
        analyticsEventProductDetail,
        analyticsEventRequestSize,
        analyticsEventPdpDetailLayer,
        analyticsEventPdpSizeGuideLayer,
        analyticsEventPdpColorLayer,
        analyticsEventPdpColorLayerSelect,
        analyticsEventPdpCarouselSwitch,
        analyticsEventConfirmLayerAddToCart,
        analyticsProductRelatedClick,
        analyticsEventStoriesMenuClick,
    }
}

export {useAnalytics}
